/**
 * VehicleMaintenance actions
 */
export enum VehicleMaintenanceActionEnum {
	/**
	 * Set maintenance status to approved
	 */
	APPROVE = 'approve',

	/**
	 * Set maintenance status to rejected
	 */
	REJECT = 'reject',

	/**
	 * Set maintenance status to completed
	 */
	COMPLETE = 'complete',

	/**
	 * Set maintenance status to pending
	 */
	PENDING = 'make_pending',

	/**
	 * Set maintenance status to in progress
	 */
	IN_PROGRESS = 'make_in_progress',

	/**
	 * Set maintenance status to in progress
	 */
	CANCEL = 'cancel',

	/**
	 * Schedule road worthy check date
	 */
	CHECK_IN = 'check_in',

	/**
	 * Schedule road worthy check date
	 */
	CHECK_OUT = 'check_out',
}
